import { Toolbar } from "primereact/toolbar";
import { ILogin, IPermissionProps } from "../../models/Login";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import React, { useEffect, useRef, useState } from "react";
import { Button } from "primereact/button";
import { Fetch } from "../../shared/Fetch";
import { IModal } from "./IVRUserList";
import { format } from "date-fns";
import { safeFormatDate } from "../../models/DateFormatMapper";

export interface IVRUserList {
    extension_ID?: number,
    callerID?: string,
    ext_Destination?: number,
    displayName?: string,
};

interface Iprops {
    setModal: (modal: IModal) => void,
    toast: any,
    reload: boolean,
    permissions: IPermissionProps,
    setReload: (is: boolean) => void,
}

export const EmptyExtCalling = {
    displayName: "",
}

export const Table = (props: Iprops) => {

    const [tableData, setTableData] = useState({ tableData: [], loading: false } as { tableData: Array<IVRUserList>, loading: boolean });
    const dt = useRef<any>(null);

    const _roles: Array<number> = [];
    const loginObj: ILogin = JSON.parse(sessionStorage.getItem('auth') + '');
    loginObj.roles.forEach(role => {
        _roles.push(role.role_ID);
    });


    const header = (
        <div className="flex flex-column md:flex-row md:justify-content-between md:align-items-center">
            <h5 className="m-0">IVR User Lists</h5>
        </div>
    );

    const openNew = () => {
        props.setModal({ open: true, singleData: EmptyExtCalling });
    };
    const openEdit = (rowData: IVRUserList) => {
        props.setModal({ open: true, singleData: rowData });
    };
    const action = (rowData: IVRUserList) => {
        return (
            <div className="flex gap-3">
                <Button className="pi pi-pencil text-primary bg-white border-none" onClick={() => openEdit(rowData)}></Button>
            </div>
        );
    }

    const loadTableData = async () => {
        setTableData({ tableData: tableData.tableData, loading: true });
        const response = await Fetch("Calling_Extension/IverUserList", "GET", null, null, props.toast);
        if (response) {
            const data = await response.json();
            setTableData({ tableData: data, loading: false });
        }
    }

    const CreatedOn = (rowData: any) => {
        let date;
        if (rowData.added_On) date = format(new Date(rowData.added_On), 'dd/MM/yyyy').toUpperCase();
        else date = "";
        return (<>{date}</>);
    };

    useEffect(() => {
        loadTableData();
    }, [props.reload]);

    const DateFormat = loginObj?.date_Format;
    return (
        <>
            <DataTable style={{ border: '1px solid rgba(105,105,105,0.17)', borderTopWidth: "0" }}
                ref={dt} size="small" stripedRows scrollable scrollHeight="75vh"
                value={tableData.tableData}
                resizableColumns showGridlines columnResizeMode="expand"
                emptyMessage="No Requirements found."
                header={header}
                loading={tableData.loading}
            >
                <Column header="SN." body={(data, options) => options.rowIndex + 1} />
                <Column field="ivr_Users_Name" header="User Name" />
                <Column field="companyName" header="Branch Name" />

                <Column field="callerID" header="Caller ID" />
                <Column field="ext_Destination" header="Ext/ Designation" />
                <Column field="added_by" header="Added By" />
                {/* <Column field="added_On" header="Created On" body={CreatedOn} /> */}
                <Column field="added_On" header="Created On" body={(rowData: any) => safeFormatDate(rowData.added_On, "dd/MM/yyyy", DateFormat)}  />
            </DataTable>
        </>
    );
}